<script lang="ts">
	import CalibrationOverlayFailed from "./CalibrationOverlay_Failed.svelte"
	import CalibrationOverlayFinished from "./CalibrationOverlay_Finished.svelte"
	import CalibrationOverlayInstructions from "./CalibrationOverlay_Instructions.svelte"
	import CalibrationOverlayLoading from "./CalibrationOverlay_Loading.svelte"
	import CalibrationOverlayTroubleshooter from "./CalibrationOverlay_Troubleshooter.svelte"
	import { Device } from "luxedo-data"
	import { Responsive } from "responsive"
	import { CalibrationController } from "../CalibrationController.svelte"

	import type { Component } from "../../../../../types/SvelteTypes"

	interface Props {
		device: Device
	}

	let { device }: Props = $props()

	const CALIBRATION_COMPS = {
		[-2]: CalibrationOverlayTroubleshooter,
		[-1]: CalibrationOverlayFailed,
		0: CalibrationOverlayInstructions,
		1: CalibrationOverlayLoading,
		2: CalibrationOverlayFinished,
	}

	let activeStepIndex: number = $derived(CalibrationController.runs[device.id]?.step)
	let CurrentStep: Component = $derived(CALIBRATION_COMPS[activeStepIndex])
	let isMobile = $derived(Responsive.isMobile)
</script>

<div id="projector-calibration" class:isMobile>
	<CurrentStep {device} />
</div>

<style>
	#projector-calibration {
		padding-top: 3rem;
		padding-bottom: 1rem;
		box-sizing: border-box;

		display: flex;
		flex-direction: column;
		justify-content: center;
		min-width: 42rem;
		min-height: 24rem;

		max-width: 100%;

		position: relative;
		align-items: center;
	}

	#projector-calibration :global(.button-container) {
		position: absolute;
		right: -2rem;
		bottom: -2rem;
		margin-bottom: 0;
		justify-content: flex-end;
	}

	#projector-calibration :global(.calibration-top) {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 16rem;
	}

	#projector-calibration :global(.calibration-bottom) {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
	}

	#projector-calibration :global(.calibration-bottom h3) {
		font-size: var(--h2);
		margin: 0;
		text-align: center;
	}

	#projector-calibration :global(.calibration-bottom p) {
		margin-top: 0.5rem;
		font-size: var(--h3);
		color: var(--color-text);
		width: 30rem;
	}

	#projector-calibration.isMobile {
		min-height: unset;
		min-width: 0;
		width: 100%;
		height: 100%;
		justify-content: space-evenly;
		padding-bottom: 3rem;
	}

	#projector-calibration.isMobile :global(.calibration-bottom p) {
		width: fit-content;
		line-height: 1.25rem;
		padding: 0 0.5rem;
		text-align: center;
		min-height: 4rem;
	}

	#projector-calibration.isMobile :global(.calibration-top) {
		height: 14rem;
		padding: 1rem 0;
	}

	#projector-calibration.isMobile :global(.button-container) {
		right: 0;
		bottom: 0;
	}

	#projector-calibration.isMobile :global(.button-container button) {
		font-size: var(--h3);
		padding: 0.1rem 0.5rem;
	}
</style>
